import { render, staticRenderFns } from "./ArgInputProductSku.vue?vue&type=template&id=08441df9"
import script from "./ArgInputProductSku.vue?vue&type=script&lang=ts"
export * from "./ArgInputProductSku.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08441df9')) {
      api.createRecord('08441df9', component.options)
    } else {
      api.reload('08441df9', component.options)
    }
    module.hot.accept("./ArgInputProductSku.vue?vue&type=template&id=08441df9", function () {
      api.rerender('08441df9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scripts/ArgInputProductSku.vue"
export default component.exports